export default __webpack_public_path__ + "images/rango-doc_185b42.svg";